// Automatically generated from TW.Saga.Core.Schema, Version=1.0.0.0, Culture=neutral, PublicKeyToken=null @30.07.2019 13:39:32
import { CrisisMessageLocation_abstract } from './../abstract/SagaSchema/CrisisMessageLocation_abstract';
export class CrisisMessageLocation extends CrisisMessageLocation_abstract {}
